"use strict";
//Direct copy paste from Frontend.Shared
// Not adding it into packaged json due to all the depdencies that you'd normally need for it but this repo doesn't need any of that.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsActionType = exports.AnalyticsEventNames = void 0;
var AnalyticsEventNames;
(function (AnalyticsEventNames) {
    AnalyticsEventNames["PROCESS_ACTIVATION"] = "process.activation";
    AnalyticsEventNames["PROCESS_LOGIN"] = "process.login";
    AnalyticsEventNames["PROCESS_OVERVIEW"] = "process.overview";
    AnalyticsEventNames["PROCESS_PAYMENT"] = "process.payment";
    AnalyticsEventNames["PROCESS_BILLS"] = "process.bills";
    AnalyticsEventNames["PROCESS_SETTINGS"] = "process.settings";
    AnalyticsEventNames["PROCESS_LOGOUT"] = "process.logout";
    AnalyticsEventNames["PROCESS_REWARDS"] = "process.rewards";
    AnalyticsEventNames["PROCESS_USAGE"] = "process.usage";
    AnalyticsEventNames["PROCESS_RETRIEVE_LOGIN_EMAIL"] = "process.retrieveLoginEmail";
    AnalyticsEventNames["PROCESS_RESET_PASSWORD"] = "process.resetPassword";
    AnalyticsEventNames["PROCESS_WEB_PAYMENT"] = "process.web.payment";
})(AnalyticsEventNames = exports.AnalyticsEventNames || (exports.AnalyticsEventNames = {}));
var AnalyticsActionType;
(function (AnalyticsActionType) {
    AnalyticsActionType["LOAD"] = "Load";
    AnalyticsActionType["CLICK"] = "Click";
    AnalyticsActionType["ERROR"] = "Error";
})(AnalyticsActionType = exports.AnalyticsActionType || (exports.AnalyticsActionType = {}));
//# sourceMappingURL=GoogleAnalytics.js.map